export default "__VITE_ASSET__CvBxt03g__"